import { ModelJson, Region } from '../types/model';

export const isModelFetched = (model: ModelJson | null) => model !== null;

export const selectCurrentRegion = (regions?: Region[], regionId?: string) =>
  regions?.find(({ regionId: region }) => regionId === region) ?? null;
